<template>
  <div class="family_group">
    <div class="family_title">我的家庭/我的同辈</div>
    <div class="flex Flexalign mt-20 FlexBetween family_top">
      <el-input v-model="searchLabel" style="width: 300px;height: 46px;" size="large" placeholder="搜索联系人 关系">
        <!-- 自定义后缀图标 -->
        <template #suffix>
          <div class="search-icon-wrapper cursor_pointer" @click="handleSearch">
            <el-icon class="search-icon">
              <Search />
            </el-icon>
          </div>
        </template>
      </el-input>
      <div class="flex Flexalign cursor_pointer" @click="addFamily('')">
        <el-image class="add_family_icon" :src="iconPath('add_family_icon.png')"></el-image>
        <div class="ml-10">添加家庭成员</div>
      </div>
    </div>
    <div class="family_list flex Flexalign FlexWrap FlexBetween" v-if="familyList.length">
      <div class="family_one mt-30 flex Flexalign px-20 py-15" v-for="(item, index) in familyList" :key="index">
        <el-image class="family_avatar" :src="item.image"></el-image>
        <div class="family_info flex-1 ml-10">
          <div class="flex">
            <div class="family_name">{{ item.nickName }}</div>
            <div class="ml-10 family_relationship">{{ getRelationShipName(item.familyId) }}</div>
          </div>
          <div class="family_phone">{{ $Tools.phoneHide(item.phone) }}</div>
        </div>
        <el-icon color="#A9A9A9 cursor_pointer" @click="addFamily(item)">
          <ArrowRight />
        </el-icon>
      </div>
    </div>
    <div class="empty" v-else>
      <el-image class="moe_empty_bg_img" :src="imgPath('moe_empty_bg_img.png')"></el-image>
      <div class="emtpy-text">暂无亲戚好友 <span class="text_active cursor_pointer" @click="addFamily('')">立即添加</span></div>
    </div>
    <addFamily ref="addFamily" @refreshList="getFamilyList"></addFamily>
  </div>
</template>

<script>
import { mapState } from "vuex";
import addFamily from '@/components/popup/addFamily.vue';
export default {
  name: 'GjkcH5FamilyGroup',
  components: {
    addFamily
  },

  data() {
    return {
      searchLabel: '',
      familyList: [],
      listQuery:{
        page:1,
        pageSize:999,
        userId:'',
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      relationshipOptions: (state) => state.user.relationshipOptions,
    }),
  },

  mounted() {
    this.getFamilyList();
  },

  methods: {
    getRelationShipName(familyId){
      let familInfo = this.relationshipOptions.filter(item => item.familyId == familyId)[0];
      if(!this.$Tools.empty(familInfo)){
        return familInfo.familyName
      }else{
        return ''
      }
    },
    getFamilyList(){
      this.listQuery.userId = this.userInfo.buyerUserId;
      this.$Api.user.getFamilyList(this.listQuery).then(res=>{
        this.familyList = res.data.data;
      }).catch(()=>{})
    },
    // 搜索
    handleSearch() {

    },
    addFamily(familyInfo) {
      if (!this.$Tools.empty(familyInfo)) {
        this.$refs.addFamily.familyInfo = familyInfo;
        this.$refs.addFamily.familyInfo.familyId = String(familyInfo.familyId);
        this.$refs.addFamily.isEdit = true;
      } else {
        this.$refs.addFamily.familyInfo = {
          avatar: '',
          relationship: '',
          name: '',
          callName: '',
          phone: ''
        };
        this.$refs.addFamily.isEdit = false;
      }
      this.$refs.addFamily.addFamilyShow = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.family_group {
  min-height: 500px;

  .family_title {
    font-size: 18px;
    color: #909090;
  }

  .family_top {
    font-size: 14px;
    color: #303030;

    .add_family_icon {
      width: 32px;
      height: 32px;
    }
  }

  .family_list {
    .family_one {
      width: 298px;
      height: 72px;
      background: #FBFAFA;
      border-radius: 10px;
      box-sizing: border-box;
      flex-shrink: 0;

      .family_avatar {
        width: 42px;
        height: 42px;
        border-radius: 50%;
      }

      .family_info {
        .family_name {
          font-size: 16px;
          color: #303030;
        }

        .family_relationship {
          width: 52px;
          height: 24px;
          background: #F1F6FF;
          border-radius: 4px;
          font-size: 14px;
          color: #37A8FE;
          line-height: 24px;
          text-align: center;
        }

        .family_phone {
          font-size: 14px;
          color: #909090;
        }
      }
    }
  }

  .empty {
    text-align: center;

    .moe_empty_bg_img {
      width: 300px;
      height: 300px;
    }

    .emtpy-text {
      margin-top: -75px;
      z-index: 9;
      position: relative;
    }
  }
}
</style>